const pestRepellentPlants = [
  {
    "plant": "Basil",
    "repels": ["Aphids", "Flies", "Mosquitoes"]
  },
  {
    "plant": "Borage",
    "repels": ["Tomato hornworms", "Cabbage worms"]
  },
  {
    "plant": "Catnip",
    "repels": ["Aphids", "Squash bugs", "Beetles", "Weevils", "Ants", "Mosquitoes"]
  },
  {
    "plant": "Chamomile",
    "repels": ["Flying insects"]
  },
  {
    "plant": "Chives",
    "repels": ["Aphids", "Japanese beetles", "Carrot rust fly"]
  },
  {
    "plant": "Chrysanthemums",
    "repels": ["Roaches", "Ticks", "Fleas", "Lice", "Silverfish"]
  },
  {
    "plant": "Dill",
    "repels": ["Aphids", "Spider mites", "Squash bugs"]
  },
  {
    "plant": "Fennel",
    "repels": ["Aphids", "Slugs", "Snails"]
  },
  {
    "plant": "Garlic",
    "repels": ["Aphids", "Japanese beetles", "Spider mites", "Carrot root fly", "Root maggots"]
  },
  {
    "plant": "Lavender",
    "repels": ["Moths", "Fleas", "Flies", "Mosquitoes"]
  },
  {
    "plant": "Lemon Balm",
    "repels": ["Mosquitoes", "Gnats", "Flies"]
  },
  {
    "plant": "Marigolds",
    "repels": ["Nematodes", "Whiteflies", "Aphids", "Beetles"]
  },
  {
    "plant": "Mints",
    "repels": ["Ants", "Aphids", "Cabbage moths", "Flea beetles", "Rodents"]
  },
  {
    "plant": "Nasturtiums",
    "repels": ["Squash bugs", "Cucumber beetles", "Aphids"]
  },
  {
    "plant": "Onions",
    "repels": ["Aphids", "Japanese beetles", "Rabbits"]
  },
  {
    "plant": "Oregano",
    "repels": ["Garden pests"]
  },
  {
    "plant": "Rosemary",
    "repels": ["Cabbage moths", "Carrot flies", "Bean beetles"]
  },
  {
    "plant": "Sage",
    "repels": ["Cabbage moths", "Carrot rust flies", "Bean parasites"]
  },
  {
    "plant": "Shallots",
    "repels": ["Aphids", "Japanese beetles", "Root maggots"]
  },
  {
    "plant": "Thyme",
    "repels": ["Cabbage worms", "Corn earworms", "Whiteflies", "Tomato hornworms"]
  },
  {
    "plant": "Petunias",
    "repels": ["Aphids", "Asparagus beetles", "Leafhoppers", "Squash bugs"]
  },
  {
    "plant": "Tansy",
    "repels": ["Flying insects", "Ants", "Cucumber beetles", "Squash bugs"]
  },
  {
    "plant": "Rue",
    "repels": ["Japanese beetles", "Flies", "Mosquitoes", "Slugs", "Snails"]
  },
  {
    "plant": "Wormwood",
    "repels": ["Moths", "Flies", "Mosquitoes", "Fleas", "Slugs"]
  },
  {
    "plant": "Citronella Grass",
    "repels": ["Mosquitoes", "Flying insects"]
  },
  {
    "plant": "Lemongrass",
    "repels": ["Mosquitoes", "Flying insects"]
  },
  {
    "plant": "Calendula",
    "repels": ["Asparagus beetles", "Tomato hornworms"]
  },
  {
    "plant": "Cosmos",
    "repels": ["Aphids"]
  },
  {
    "plant": "Cilantro",
    "repels": ["Aphids", "Spider mites", "Potato beetles"]
  }
];

// Export the pest repellent plants array for ES6 modules
export { pestRepellentPlants };